/*
 * File Created: Tuesday, 16th May 2023 8:13:23 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

export const phoneNoValidatorRegx = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
export const emailValidatorRegx = /\S+@\S+\.\S+/;